var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_18885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7188 24.3672H19.7188V19.3242C19.718 18.5402 19.4062 17.7885 18.8518 17.2341C18.2974 16.6798 17.5458 16.368 16.7617 16.3672H8.67575C7.89175 16.368 7.14009 16.6798 6.58571 17.2341C6.03134 17.7885 5.71954 18.5402 5.71875 19.3242V24.3672H3.71875V19.3242C3.72034 18.01 4.2431 16.7501 5.17238 15.8208C6.10165 14.8915 7.36156 14.3688 8.67575 14.3672H16.7617C18.0759 14.3688 19.3359 14.8915 20.2651 15.8208C21.1944 16.7501 21.7172 18.01 21.7188 19.3242V24.3672Z",
    fill: "#253D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7188 12.3672C11.5321 12.3672 10.372 12.0153 9.38533 11.356C8.39864 10.6967 7.6296 9.75965 7.17548 8.66329C6.72135 7.56693 6.60253 6.36053 6.83404 5.19665C7.06555 4.03276 7.637 2.96366 8.47611 2.12455C9.31523 1.28543 10.3843 0.71399 11.5482 0.482479C12.7121 0.250967 13.9185 0.369787 15.0149 0.823913C16.1112 1.27804 17.0483 2.04707 17.7076 3.03377C18.3669 4.02046 18.7188 5.1805 18.7188 6.36719C18.7172 7.958 18.0845 9.4832 16.9596 10.6081C15.8348 11.733 14.3096 12.3656 12.7188 12.3672V12.3672ZM12.7188 2.36719C11.9276 2.36719 11.1543 2.60179 10.4965 3.04131C9.83868 3.48084 9.32598 4.10555 9.02323 4.83646C8.72048 5.56736 8.64127 6.37163 8.79561 7.14755C8.94995 7.92348 9.33092 8.63621 9.89033 9.19562C10.4497 9.75503 11.1625 10.136 11.9384 10.2903C12.7143 10.4447 13.5186 10.3655 14.2495 10.0627C14.9804 9.75996 15.6051 9.24727 16.0446 8.58947C16.4842 7.93167 16.7188 7.15832 16.7188 6.36719C16.7188 5.30632 16.2973 4.28891 15.5472 3.53876C14.797 2.78862 13.7796 2.36719 12.7188 2.36719Z",
    fill: "#253D4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_18885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.71875 0.367188)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.3fc39544360c791f9e030357f825b4f0.svg";
export { ForwardRef as ReactComponent };